// import React, { useCallback, useEffect, useState } from "react";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import { ToastContainer } from "react-toastify";
// import Select from 'react-select';
// import { Col, Container, Row, Table } from "react-bootstrap";
// import AuthNavbar from "../components/AuthNavbar/AuthNavbar";

// function AttendanceHistory() {
//   const userinfo = useSelector((state) => state);
//   const { currentLocal } = useSelector((state) => state.currentLocal);
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [classState, setClassState] = useState('');
//   const [classOptions, setClassOptions] = useState([]);
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');

//   const fetchData = useCallback(async () => {
//     if (fromDate && toDate) {
//       try {
//         const res = await axios.get(
//           `https://nanosoft.space/taarteb/public/api/history?from=${fromDate}&to=${toDate}`,
//           {
//             headers: {
//               Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//             },
//           }
//         );

//         // const groupedByClass = {};
//         setAttendanceData(res.data.data.data)
//         // res.data.data.data.forEach((item) => {
//         //   if (!groupedByClass[item.class]) groupedByClass[item.class] = [];
//         //   groupedByClass[item.class].push(item);
//         // });

//         // const uniqueClass = Array.from(
//         //   new Set(res.data.data.data.map((item) => item.class))
//         // ).map((year) => ({
//         //   value: year,
//         //   label: ` ${year}`,
//         // }));

//         // setClassOptions(uniqueClass);
//         // setAttendanceData(groupedByClass);
//       } catch (err) {
//         console.error(err.response);
//       }
//     }
//   }, [fromDate, toDate, userinfo.auth.userArray.access_token]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const sessionsPerDay = 8;

//   return (
//     <div className="">
//       <ToastContainer />
//       <div className="px-0 my-3 w-100 dashboard_content">
//         <Container>
//           <div className="d-flex flex-column w-100">
//             <AuthNavbar />
//             <div className="mt-5 mx-3">
//               <Container className="mb-4">
//                 <Row>
//                   <Col md={3}>
//                     <p className="mb-1">{currentLocal.home.from}</p>
//                     <input
//                       type="date"
//                       value={fromDate}
//                       onChange={(e) => setFromDate(e.target.value)}
//                       style={{
//                         width: "100%",
//                         marginBottom: "18px",
//                         border: "1px solid #dee2e6",
//                         borderRadius: "4px",
//                         height: "42px",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         paddingLeft: "8px",
//                         paddingRight: "8px",
//                         color: "#000",
//                       }}
//                     />
//                   </Col>
//                   <Col md={3}>
//                     <p className="mb-1">{currentLocal.home.to}</p>
//                     <input
//                       type="date"
//                       value={toDate}
//                       onChange={(e) => setToDate(e.target.value)}
//                       style={{
//                         width: "100%",
//                         marginBottom: "18px",
//                         border: "1px solid #dee2e6",
//                         borderRadius: "4px",
//                         height: "42px",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         paddingLeft: "8px",
//                         paddingRight: "8px",
//                         color: "#000",
//                       }}
//                     />
//                   </Col>
//                   {/* <Col md={3}>
//                     <p className="mb-1">{currentLocal.home.SelectClass}</p>
//                     <Select
//                       value={classState}
//                       onChange={(selectedOption) => setClassState(selectedOption)}
//                       options={classOptions}
//                       placeholder={currentLocal.home.SelectClass}
//                     />
//                   </Col> */}
//                   <Col md={3}>
//                     <button onClick={() => window.print()} className="btn  border mb-3 mt-3">
//                       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
//                         <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
//                         <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
//                       </svg>
//                     </button>
//                   </Col>
//                 </Row>
//               </Container>

//       {fromDate && toDate&&
//                                 <Table  striped bordered hover 
//                                 responsive 
//   className="custom-main-table attendance-table"

//                                 >


//                             <thead>
//                               <tr>
//                                 <th rowSpan={2}>{currentLocal.home.students}</th>
//                                 <th rowSpan={2}>{currentLocal.home.grade}</th>
//                                 <th rowSpan={2}>{currentLocal.home.Stage}</th>

//                                 <th rowSpan={2}>{currentLocal.home.date}</th>
//                                 <th rowSpan={2}>{currentLocal.home.AttendedAbsent}</th>

// </tr>
// </thead>

// <tbody>
//   {attendanceData.map((item,index)=>{
//     console.log(item);
    
//     return(
//   <tr>
//     <td>{item?.student}</td>
//     <td>{item?.grade}</td>
//     <td>{item?.stage}</td>
//     <td>{item?.created_at.slice(0,10)}</td>
//     <td>{item?.is_present==1?currentLocal.home.present:currentLocal.home.Absent}</td>

//   </tr>
//     )
//   })}

// </tbody>

// </Table>




//       }
//             </div>
//           </div>
//         </Container>
//       </div>
//     </div>
//   );
// }

// export default AttendanceHistory;

import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Col, Container, Row, Table, Form } from "react-bootstrap";
import AuthNavbar from "../components/AuthNavbar/AuthNavbar";

function AttendanceHistory() {
  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [attendanceData, setAttendanceData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  // حالات حقول البحث والتصفية الجديدة
  const [searchStudent, setSearchStudent] = useState('');
  const [searchGrade, setSearchGrade] = useState('');
  const [searchStage, setSearchStage] = useState('');
  const [searchDate, setSearchDate] = useState('');
  const [searchStatus, setSearchStatus] = useState('');

  const fetchData = useCallback(async () => {
    if (fromDate && toDate) {
      try {
        const res = await axios.get(
          `https://nanosoft.space/taarteb/public/api/history?from=${fromDate}&to=${toDate}`,
          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            },
          }
        );
        setAttendanceData(res.data.data.data);
      } catch (err) {
        console.error(err.response);
      }
    }
  }, [fromDate, toDate, userinfo.auth.userArray.access_token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // تصفية البيانات (Filtering) بناءً على المدخلات الجديدة
  const filteredData = attendanceData.filter((item) => {
    const studentMatch = item?.student?.toLowerCase().includes(searchStudent.toLowerCase());
    const gradeMatch = item?.grade?.toLowerCase().includes(searchGrade.toLowerCase());
    const stageMatch = item?.stage?.toLowerCase().includes(searchStage.toLowerCase());
    const dateMatch = searchDate ? item?.created_at?.includes(searchDate) : true;
    
    let statusMatch = true;
    if (searchStatus === '1') {
      statusMatch = item?.is_present == 1;
    } else if (searchStatus === '0') {
      statusMatch = item?.is_present == 0;
    }

    return studentMatch && gradeMatch && stageMatch && dateMatch && statusMatch;
  });

  return (
    <div className="">
      <ToastContainer />
      <div className="px-0 my-3 w-100 dashboard_content">
        <Container>
          <div className="d-flex flex-column w-100">
            <AuthNavbar />
            <div className="mt-5 mx-3">
              <Container className="mb-4">
                <Row className="g-3">
                  <Col md={3}>
                    <p className="mb-1">{currentLocal.home.from}</p>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      style={{
                        width: "100%",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        height: "42px",
                        padding: "0 8px",
                        color: "#000",
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <p className="mb-1">{currentLocal.home.to}</p>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      style={{
                        width: "100%",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        height: "42px",
                        padding: "0 8px",
                        color: "#000",
                      }}
                    />
                  </Col>
                  <Col md={3} className="d-flex align-items-end">
                    <button onClick={() => window.print()} className="btn border w-100" style={{ height: "42px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer me-2" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                      </svg>
                      Print
                    </button>
                  </Col>
                </Row>

                {/* حقول البحث والتصفية الإضافية */}
                {fromDate && toDate && (
                  <Row className="mt-3 g-3">
                    <Col md={currentLocal.language==='العربيه' ? '' : undefined} sm={6}>
                      <Form.Control
                        type="text"
                        placeholder={currentLocal.home.Searchbystudentname}
                        value={searchStudent}
                        onChange={(e) => setSearchStudent(e.target.value)}
                      />
                    </Col>
                    <Col sm={6} md={2}>
                      <Form.Control
                        type="text"
                        placeholder={currentLocal.home.Searchbystudentname}
                        value={searchGrade}
                        onChange={(e) => setSearchGrade(e.target.value)}
                      />
                    </Col>
                    <Col sm={6} md={2}>
                      <Form.Control
                        type="text"
                        placeholder={currentLocal.home.filterByStage}
                        value={searchStage}
                        onChange={(e) => setSearchStage(e.target.value)}
                      />
                    </Col>
                    <Col sm={6} md={2}>
                      <Form.Control
                        type="date"
                        value={searchDate}
                        onChange={(e) => setSearchDate(e.target.value)}
                      />
                    </Col>
                    <Col sm={6} md={2}>
                      <Form.Select
                        value={searchStatus}
                        onChange={(e) => setSearchStatus(e.target.value)}
                      >
                        <option value="">{currentLocal.home.all}</option>
                        <option value="1">{currentLocal.home.present}</option>
                        <option value="0">{currentLocal.home.Absent}</option>
                      </Form.Select>
                    </Col>
                  </Row>
                )}
              </Container>

              {fromDate && toDate && (
                <Table striped bordered hover responsive className="custom-main-table attendance-table">
                  <thead>
                    <tr>
                      <th>{currentLocal.home.students}</th>
                      <th>{currentLocal.home.grade}</th>
                      <th>{currentLocal.home.Stage}</th>
                      <th>{currentLocal.home.date}</th>
                      <th>{currentLocal.home.AttendedAbsent}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.student}</td>
                          <td>{item?.grade}</td>
                          <td>{item?.stage}</td>
                          <td>{item?.created_at?.slice(0, 10)}</td>
                          <td>
                            {item?.is_present == 1
                              ? currentLocal.home.present
                              : currentLocal.home.Absent}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">No matching records found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default AttendanceHistory;